import React from 'react';
import { Table, Input, Select, Button, Tooltip, Icon, message,Modal } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';
import ExportUtil from '../../common/ExportUtil';

const { Option } = Select;
const Status = {
    EXPORTING: '导出中',
    WAITING: '等待中',
    FINISHED: '已完成',
};
const StatusOption = Object.keys(Status).map(key => <Option key={key}>{Status[key]}</Option>);
const Tip = (
    <div>
        等待中：当前有其他导出任务正在执行，需要等待<br />
        （括号中的数字表示当前等待的导出任务数量）<br />
        导出中：当前导出任务正在执行<br />
        已完成：当前导出任务已执行完毕，可以下载文件
    </div>
);

class DownloadSite extends React.Component {
    state = {
        pagination: {
            pageSize: 10,
            current: 1,
        },
        searchParams: {},
        loading: false,
        data: [],
        visible:false
    }
    show= () =>{
        this.loadData();
    }
    hide = () => {
        this.setState({ visible: false });
    }
    
    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { pagination, searchParams } = this.state;
        const { pageSize, current } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.queryAsynchronousExport,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    loading: false,
                    data: datas,
                    visible:true
                });
            },
            errorResult: res => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options)
    }

    download = (asynchronousExportId) => {
        let url = API_URL.common.downloadAsynchronousExport;
        ExportUtil.export({ asynchronousExportId }, null, url);
    }

    deleteConfirm = (record) => {
        const { asynchronousExportId, status } = record
        if (status === 'EXPORTING') {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{marginLeft: 42}}>该文件正在导出生成中，是否确认删除？</div>,
                onOk: () => {
                    this.delete(asynchronousExportId);
                },
            });
        } else { 
            this.delete(asynchronousExportId);
        }
    }

    delete = (asynchronousExportId) => {
        const options = {
            method: 'POST',
            url: API_URL.common.deleteAsynchronousExport,
            data: {asynchronousExportId},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        }
        $.sendRequest(options)
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        switch (key) {
            default:
                searchParams[key] = value;
                break;
        }
        this.setState({ searchParams });
    }

    getColumns = () => [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '文件名称',
            dataIndex: 'fileName',
            key: 'fileName',
        },
        {
            title: '标签',
            dataIndex:'remarkList',
            key:'remarkList' ,
            width: 180,
            render: (remarkList) => {
                return(
                    <span>
                        {
                            
                            remarkList?remarkList.map( e => <div key={e}>{e}</div>):null
                        }
                    </span>
                    
                )
            },
        },
        {
            title: '创建时间',
            dataIndex: 'exportTime',
            key: 'exportTime',
        }, {
            title: (
                <span>
                    导出状态
                    <Tooltip overlayClassName="downloadSite" placement="top" title={Tip}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'statusDescribe',
            key: 'statusDescribe',
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            render: (text, record) => {
                return (
                    <span>
                        {
                            record.status !== 'FINISHED' ?
                                <a disabled={true}>下载</a>
                            :
                                <a onClick={() => this.download(record.asynchronousExportId)}>下载</a>
                        }
                        <span className="ant-divider" />
                        <a onClick={() => this.deleteConfirm(record)}>删除</a>
                    </span>
                )
            }
        }
    ]

    getDataSource = () => {
        const { data = [], pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) =>({
            index: pageSize * (current - 1) + index + 1,
            ...item,
        }));
       return dataSource; 
    }

    handleTableChange = (pagination) => {
        this.setState({ pagination }, () => {
            this.loadData();
        })
    }

    render() {
        const { loading, pagination, searchParams,visible } = this.state;
        return (
            <Modal
                    title="下载站"
                    visible={visible}
                    onCancel={this.hide}
                    className="creat-modal EditPersonModal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width={1300}
                    footer={<Button onClick={this.hide}>关闭</Button>}
                >
                    <div className="full">
                <div className="content-2">
                    <div style={{ marginTop: 10 }}>
                        <div className="search-bar" style={{ marginBottom: 10 }}>
                            <div className="search-item">
                                <label htmlFor="" className="ui-label">文件名称</label>
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 160 }}
                                    value={searchParams.fileName}
                                    onChange={e => this.handleChange(e.target.value, 'fileName')}
                                />
                            </div>
                            <div className="search-item">
                                <label htmlFor="" className="ui-label">导出状态</label>
                                <Select
                                    allowClear={true}
                                    placeholder="请选择"
                                    style={{ width: 120 }}
                                    value={searchParams.status}
                                    onChange={value => this.handleChange(value, 'status')}
                                >
                                    {StatusOption}
                                </Select>
                            </div>
                            <div className="search-item">
                                <Button type="primary" onClick={this.search}>搜索</Button>
                            </div>
                        </div>
                        <Table
                            bordered
                            loading={loading}
                            scroll={{x: 1130}}
                            pagination={pagination}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.index}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </div>

            </div>
                </Modal>
        );
    }
}

export default DownloadSite;




// WEBPACK FOOTER //
// ./src/components/layout/DownloadSite.js